import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-input',
    template:
        `
    <input type="number" [formControl]="formControl" [formlyAttributes]="field" class="form-control" >
    `,
})
export class FormlyNumericInputComponent extends FieldType<FieldTypeConfig> implements OnInit {

    ngOnInit() {
        console.log('FormlyNumericInputComponent');
        console.log(this.field);
    }

}
